import { assetContainerTypes } from './asset-container-action-types';
import { authorizedRequest } from '../../common/request';

export const toggleResort = () => {
			
    return {
        type: assetContainerTypes.ASSET_CONTAINER_TOGGLE_RESORT,
            
    };
};

export const startResort = (originalValues) => {
			
    return {
        type: assetContainerTypes.ASSET_CONTAINER_START_RESORT,
        originalValues
            
    };
};


export const cancelResort = (originalValues) => {
			
    return {
        type: assetContainerTypes.ASSET_CONTAINER_CANCEL_RESORT,
        originalValues
            
    };
};
export const cancelResortAlbum = (originalValues) => {

    return {
        type: assetContainerTypes.ASSET_CONTAINER_CANCEL_RESORT_ALBUM,
        originalValues

    };
};
export const stopResort = () => {
			
    return {
        type: assetContainerTypes.ASSET_CONTAINER_STOP_RESORT,
            
    };
};
export const stopResortAlbum = () => {

    return {
        type: assetContainerTypes.ASSET_CONTAINER_STOP_RESORT_ALBUM,

    };
};

export const moveAssetAfter = (itemToMove, itemToMoveAfter) => {
    return {
        type: assetContainerTypes.ASSET_CONTAINER_MOVE_ASSET_AFTER,
        element: {assetId: itemToMove, moveAfterAssetId: itemToMoveAfter}
    };
};
export const moveAlbumAssetAfter = (itemToMove, itemToMoveAfter) => {
    return {
        type: assetContainerTypes.ASSET_CONTAINER_MOVE_ALBUM_ASSET_AFTER,
        element: {assetId: itemToMove, moveAfterAssetId: itemToMoveAfter}
    };
};


export const saveArrangedAlbumItems = (dispatch, request) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/cces`;
   
    uri += "/displayorder";
    authorizedRequest(uri, request, "POST")
        .then((data)=>{
               
                dispatch({
                    type: assetContainerTypes.ASSET_CONTAINER_SAVE_ALBUM_SORT_SUCCESS,
                    element:request
                });

            }
        )
        .catch(error => {
            alert(JSON.stringify(error));
            dispatch({
                    type: assetContainerTypes.ASSET_CONTAINER_SAVE_ALBUM_SORT_FAILURE,
                    element: error
                });
            }
        );

    return {
        type: assetContainerTypes.ASSET_CONTAINER_SAVE_ALBUM_SORT
    };
};
export const saveArrangedAlbums = (dispatch, request) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/cc`;

    uri += "/displayorder";
    authorizedRequest(uri, request, "POST")
        .then((data)=>{

                dispatch({
                    type: assetContainerTypes.ASSET_CONTAINER_SAVE_ALBUM_SORT_SUCCESS,
                    element:request
                });

            }
        )
        .catch(error => {
                alert(JSON.stringify(error));
                dispatch({
                    type: assetContainerTypes.ASSET_CONTAINER_SAVE_ALBUM_SORT_FAILURE,
                    element: error
                });
            }
        );

    return {
        type: assetContainerTypes.ASSET_CONTAINER_SAVE_ALBUM_SORT
    };
};

export const dragStart  = (dragDropData) => {
    return {
        type: assetContainerTypes.ASSET_CONTAINER_DRAG_START,
        dragDropData: dragDropData
    }
}







// WEBPACK FOOTER //
// ./src/assetContainer/actions/asset-container-actions.js